module.exports = __webpack_public_path__ + "img/osa_hub.18c9ffbd.svg";